import { useMemo } from 'react';

import { ItemAvailabilityStatus } from 'enums/menu';
import useFoodWareData from 'hooks/use-foodware';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useMenuContext } from 'state/menu';

export type TUtensil = {
  id: string;
  name: string;
  isAvailable: boolean;
};

export const useUtensils = () => {
  const isUtensilsSectionEnabled = useFlag(LaunchDarklyFlag.ENABLE_FOODWARE_ITEMS);
  const { getOneMenuItemAvailability } = useMenuContext();
  const { featureFoodware, loading } = useFoodWareData();

  const utensils: TUtensil[] | undefined = useMemo(
    () =>
      featureFoodware?.items?.map(item => ({
        id: item?._id || '',
        name: item?.name?.locale || '',
        isAvailable:
          getOneMenuItemAvailability(item._id).availabilityStatus ===
          ItemAvailabilityStatus.AVAILABLE,
      })),
    [featureFoodware?.items, getOneMenuItemAvailability]
  );

  return {
    isUtensilsSectionEnabled,
    utensils,
    loading,
  };
};
